

import React, { useState, useEffect } from "react";
import axiosInstance from "../networking/axiosconfig";


const TimeLineView = ({ userId }) => {
  const [timelineData, setTimelineData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("2025-03");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const [tooltip, setTooltip] = useState(null);

  const statusClasses = {
    Present: "bg-green-200 text-green-800 border-green-600",
    Absent: "bg-red-200 text-red-800 border-red-600",
    Holiday: "bg-blue-200 text-blue-800 border-blue-600",
    Leave: "bg-purple-200 text-purple-800 border-purple-600",
    Weekend: "bg-yellow-200 text-yellow-800 border-yellow-600",
    WeekendButPresent: "bg-green-200 text-green-800 border-green-600",
    HolidayButPresent: "bg-green-200 text-green-800 border-green-600",
    LeaveButPresent: "bg-green-200 text-green-800 border-green-600",
  };
  useEffect(() => {
    if (!userId || !selectedMonth) return;

    const fetchAttendanceData = async () => {
      const startDate = `${selectedMonth}-01`;
      const lastDate = new Date(2025, parseInt(selectedMonth.split("-")[1]), 0).getDate();
      const endDate = `${selectedMonth}-${lastDate}`;

      try {
        // Fetch Attendance Data
        const attendanceResponse = await axiosInstance.get(
          `/api/attendance/getattendanceListByDate`,
          { params: { userId, startdate: startDate, enddate: endDate } }
        );

        // Fetch Shift Data
        const shiftResponse = await axiosInstance.get(`/api/shift/${userId}`);
        const shiftData = shiftResponse.data?.data || {};
        const shiftStart = shiftData.start_time;
        const shiftEnd = shiftData.end_time;

        if (attendanceResponse.data?.data?.length > 0) {
          const attendanceRecords = attendanceResponse.data.data[0].attendance || [];

          const mappedData = attendanceRecords.map((item) => {
            // Convert timestamps to Date objects
            const checkInTime = item.check_in_time
              ? new Date(item.check_in_time * 1000)
              : null;
            const checkOutTime = item.check_out_time
              ? new Date(item.check_out_time * 1000)
              : null;

            // Convert Shift Timings to Date format
            const shiftStartTime = new Date(checkInTime);
            const shiftEndTime = new Date(checkOutTime);
            const [shH, shM, shS] = shiftStart.split(":").map(Number);
            shiftStartTime.setHours(shH, shM, shS, 0);

            // const [ehH, ehM, ehS] = shiftEnd.split(":").map(Number);
            // shiftEndTime.setHours(ehH, ehM, ehS, 0);
            shiftEndTime.setHours(shH + 8, shM, shS, 0);


            // Calculate Attendance Status
            let checkInStatus = "On-Time";
            if (checkInTime && checkInTime < shiftStartTime) checkInStatus = "Early Coming";
            if (checkInTime && checkInTime > shiftStartTime) checkInStatus = "Late Coming";


            let checkOutStatus = "On-Time";
            if (checkOutTime && checkOutTime < shiftEndTime) checkOutStatus = "Early Leaving";
            if (checkOutTime && checkOutTime > shiftEndTime) checkOutStatus = "Late Leaving";





            return {
              day: new Date(item.date).toLocaleString("en-US", { weekday: "short" }),
              date: new Date(item.date).getDate(),
              checkIn: checkInTime
                ? checkInTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
                : "N/A",
              checkOut: checkOutTime
                ? checkOutTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
                : "N/A",
              // totalHours: item.total_working_hours ? `${item.total_working_hours} Hrs` : "0 Hrs", 
              totalHours: item.total_working_hours
                ? `${Math.floor(item.total_working_hours / 60)} Hrs ${item.total_working_hours % 60} Min`
                : "0 Hrs",



              status:
                item.status === 1 ? "Present" :
                  item.status === 2 ? "Absent" :
                    item.status === 3 ? "Holiday" :
                      item.status === 4 ? "Leave" :
                        item.status === 5 ? "HolidayButPresent" :
                          item.status === 6 ? "LeaveButPresent" :
                            item.status === 7 ? "Weekend" :
                              item.status === 8 ? "WeekendButPresent" : "Unknown",
              checkInStatus,
              checkOutStatus
            };
          });

          setTimelineData(mappedData);
        } else {
          setTimelineData([]);
        }
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      }
    };

    fetchAttendanceData();
  }, [userId, selectedMonth]);

  const calculatePosition = (checkInTime, shiftStartTime, shiftEndTime) => {
    if (!checkInTime || !shiftStartTime) return "10%";

    const [startH, startM] = shiftStartTime.split(":").map(Number);
    const [checkInH, checkInM] = checkInTime.split(":").map(Number);

    const startMinutes = startH * 60 + startM;
    const checkInMinutes = checkInH * 60 + checkInM;

    const lateMinutes = Math.max(0, checkInMinutes - startMinutes); // Minutes late

    // Each 30 min = 4% increase in position
    const positionGap = (lateMinutes / 30) * 4;

    // Start at 40%, add dynamic gap
    const percentage = 40 + positionGap;

    // Ensure it stays within 40% - 70%
    return `${Math.min(70, Math.max(40, percentage))}%`;
  };






  const handleCircleClick = (type, time, position) => {
    setTooltip({ type, time, position });
    setTimeout(() => setTooltip(null), 2000);
  };

  return (
    <div className="mt-4 space-y-3">
      {timelineData.length > 0 ? (
        timelineData.map((item, index) => (
          <div key={index} className="bg-white p-6 rounded-lg shadow-md flex items-center justify-between relative">

            <div className="flex items-center relative">
              <span className="text-gray-600 font-medium">{item.day} {item.date}</span>

              <div
                className={`w-3 h-3 rounded-full ml-2 ${item.checkInStatus === "Early Coming" ? "bg-green-500" : "bg-gray-400"
                  }`}
              ></div>
            </div>

            <div className="relative flex-1 mx-4">
              <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-gray-500 rounded-full"></div>

              <div className="w-full h-1 bg-gray-200 rounded-full relative">
                {item.checkInStatus === "On-Time" && (
                  <div
                    className="absolute left-0 top-0 h-1 rounded-full bg-green-500 w-full"
                    onClick={() => handleCircleClick("Check-in", item.checkIn)}
                  ></div>
                )}

                {item.checkInStatus === "Late Coming" && (
                  <div
                    className="absolute top-1/2 transform -translate-y-1/2 w-3 h-3 bg-green-500 rounded-full"
                    style={{ left: calculatePosition(item.checkIn, startTime, endTime, true) }}
                  ></div>
                )}
              </div>

              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-gray-500 rounded-full"></div>

              {/* Status Label */}
              {item.status && (
                <span
                  className={`text-base px-4 py-1 rounded-md shadow border-l-4 ${statusClasses[item.status] || "bg-gray-200 text-gray-800 border-gray-600"
                    } absolute -top-5 left-1/2 transform -translate-x-1/2`}
                >
                  {item.status}
                </span>
              )}
            </div>

            {/* <div className="flex items-center">
              <div className="w-3 h-3 bg-gray-400 rounded-full mr-2"></div>

              {item.checkOut && (
                <div
                  className={`w-3 h-3 rounded-full ml-2 ${item.checkOutStatus === "On-Time" ? "bg-green-500" :
                    item.checkOutStatus === "Late Leaving" ? "bg-red-500" :
                      item.checkOutStatus === "Early Leaving" ? "bg-red-500" :
                        "bg-gray-400"
                    }`}
                ></div>
              )}

              {item.checkOut && (
                <>
                  <span className="text-gray-600">{item.checkIn} - {item.checkOut}</span>
                  <span className="text-gray-800 font-semibold ml-2">{item.totalHours}</span>
                </>
              )}
            </div> */}
            <div className="relative flex items-center">
              {/* Red Line for Early Checkout */}
              {/* {item.checkOutStatus === "Early Leaving" && (
                <div className="absolute -left-4 w-4 h-1 bg-red-500"></div>
              )} */}
              <div
                className={`w-3 h-3 rounded-full 
    ${item.checkOutStatus === "Late Leaving" ? "bg-yellow-500" :
                    item.checkOutStatus === "Early Leaving" ? "bg-red-500" :
                      item.checkOutStatus === "Check-out Missing" ? "bg-black" :
                        "bg-green-500"
                  }`}
              >
              </div>


              {/* Checkout Time */}
              {item.checkOut ? (
                <>
                  <span className="text-gray-600 ml-2">{item.checkIn} - {item.checkOut}</span>
                  <span className="text-gray-800 font-semibold ml-2">{item.totalHours}</span>
                </>
              ) : (
                <span className="text-black font-semibold ml-2">Check-out Missing</span>
              )}

            </div>


          </div>
        ))
      ) : (
        <div className="text-center text-gray-500 py-6">No attendance records found.</div>
      )}
    </div>

  );
};
export default TimeLineView;